import React from 'react'

import Emoji from '@generators/htmlComponents/icons/congrats.png'
import Text from './Text'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    textAlign: 'center',
    marginTop: 8,
  },
}

export const CongratulationsText = () => (
  <div style={styles.container}>
    <img
      src={Emoji}
      alt="Ícone de congratulations"
      style={{ width: 24, height: 24 }}
    />
    <Text style={{ fontSize: 12, marginTop: 8 }}>
      Parabéns pela participação nas ações de saúde preventiva! O departamento
      de Medicina Preventiva da Unimed Assis se coloca à sua disposição para
      esclarecer qualquer eventual dúvida sobre cuidados com a saúde.
    </Text>
  </div>
)
